import { useState, useEffect } from 'react';

import {
    SearchBarContainer,
    SearchButton,
    SearchInput
} from './search-bar.styles';

const SearchBar = ({
    search,
    setSearch,
    submitSearch
}) => {
    const [inputValue, setInputValue] = useState(search);

    // Sync local input when external search value changes (e.g. browser back/forward)
    useEffect(() => {
        setInputValue(search);
    }, [search]);

    const handleKeyDown = async (e) => {
        if(e.key === 'Enter') {
            setSearch(inputValue);
            await submitSearch(true);
        }
    }

    const handleSubmit = async () => {
        setSearch(inputValue);
        await submitSearch(true);
    }

    const clear = async () => {
        setInputValue('');
        setSearch('');
        submitSearch(true);
    }

    return (
        <SearchBarContainer onKeyDown={(e) => handleKeyDown(e)}>
            <SearchInput type='text' value={inputValue} onChange={(e) => setInputValue(e.target.value)} />
            <SearchButton onClick={handleSubmit}>Search</SearchButton>
            <SearchButton onClick={() => clear()}>Clear</SearchButton>
        </SearchBarContainer>
    )
}

export default SearchBar;
